module.exports = __webpack_public_path__ + "static/media/header-banner-mobile.90fd87c8.svg";